import loadable from '@loadable/component'

export const Card = loadable(() => import('./Card'))
export const Cards = loadable(() => import('./Cards'))
export type { CardsProps } from './Cards'
export type {
  CardImageProps,
  CardRenderLinkProps,
  CardRenderImageProps
} from './Card'
